import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async createCollection(
        { commit, dispatch },
        { active, content, images, keywords, name, slug, summary }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/collections", {
                name,
                content,
                summary,
                slug,
                keywords,
                images,
                active
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async listAllCollections(
        { commit, dispatch, state },
        { active, keyword = "", required }
    ) {
        if (!required) {
            const lower = keyword.toLowerCase();
            return state.collectionsAll.filter((item) => {
                const auxObj = {
                    ...{
                        ...(keyword
                            ? {
                                  keyword: item.name
                                      .toLowerCase()
                                      .includes(lower)
                              }
                            : null)
                    },
                    ...{
                        ...(active !== undefined
                            ? {
                                  active: item.active === active
                              }
                            : null)
                    }
                };
                return Object.values(auxObj).every((item2) => item2);
            });
        }
        try {
            const { data } = await Http.instance.get("/bo/collections/all", {
                params: { active, keyword }
            });
            commit("ADD_ALL_COLLECTIONS", data.items);
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async listCollectionsPaginated(
        { commit, dispatch },
        { active, complete, itemsByPage, keyword, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/collections", {
                params: { active, complete, itemsByPage, keyword, page }
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async getCollectionBySlug({ commit, dispatch }, { slug }) {
        try {
            const { data } = await Http.instance.get(`/bo/collections/${slug}`);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async updateCollection(
        { commit, dispatch },
        { active, content, images, keywords, name, slug, summary }
    ) {
        try {
            const { data } = await Http.instance.patch(
                `/bo/collections/${slug}`,
                {
                    name,
                    content,
                    summary,
                    keywords,
                    active,
                    images
                }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async deleteCollection({ commit, dispatch }, { slug }) {
        try {
            await Http.instance.delete(`/bo/collections/${slug}`);
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async listHighlightCollections({ commit, dispatch }, { lineSlug }) {
        try {
            const { data } = await Http.instance.get(
                "/bo/collections/highlight",
                {
                    params: { lineSlug }
                }
            );
            return data.items;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async updateHighlightCollections(
        { commit, dispatch },
        { collectionsSlugs, lineSlug }
    ) {
        try {
            const { data } = await Http.instance.put(
                "/bo/collections/highlight",
                {
                    lineSlug,
                    collectionsSlugs
                }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    },

    async updateCollectionsWeights({ commit, dispatch }, { collections }) {
        try {
            await Http.instance.put("/bo/collections/massive/weights", {
                collections
            });
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_COLLECTIONS", parseError);
            throw parseError;
        }
    }
};

export default actions;
